import { Inject, Injectable } from '@angular/core';

import { ButtonType, DialogType, ModalDialogService } from '@frontend/sports/modal/feature';
import { Observable, from } from 'rxjs';

import {
    BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN,
    IBetslipMessagesProviderService,
} from '../../../../base/services/betslip-messages-provider.service';

@Injectable()
export class BetslipDoubleBetPreventionDialogService {
    private readonly messages: {
        DialogButtonText: string;
        DialogText1: string;
        DialogText2: string;
        DialogTitle: string;
    };

    constructor(
        private modalDialogService: ModalDialogService,
        @Inject(BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN) messageProvider: IBetslipMessagesProviderService,
    ) {
        this.messages = messageProvider.getMessages().modalDialogs.doubleBetPrevention;
    }

    show(): Observable<number> {
        const modal = this.modalDialogService.openMessage({
            // dialogClassName: 'compact',
            type: DialogType.Warning,
            title: this.messages.DialogTitle,
            firstParagraph: this.messages.DialogText1,
            secondParagraph: this.messages.DialogText2,
            buttons: [
                {
                    text: this.messages.DialogButtonText,
                    cssClass: '',
                    type: ButtonType.Ok,
                },
            ],
        });

        return from(modal.result);
    }
}
